import { Component, computed, inject, input } from '@angular/core';
import { MbpRadioGroupComponent } from '../mbp-radio-group/mbp-radio-group.component';

@Component({
  selector: 'mbp-radio',
  templateUrl: './mbp-radio.component.html',
  styleUrl: './mbp-radio.component.scss'
})
export class MbpRadioComponent {
  value = input.required<unknown>();
  label = input<string>('');
  disabled = input<boolean>(false);

  private readonly group = inject(MbpRadioGroupComponent);

  protected selected = computed(() => this.group.value() === this.value());
  protected isDisabled = computed(() => this.disabled() || this.group.disabled());

  protected onSelect(): void {
    if (this.isDisabled()) {
      return;
    }
    this.group.select(this.value());
  }
}
